import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { API_BASE_URL, API_ENDPOINTS } from '../config/api';
import { track } from '../analytics/analytics';
import { EVENTS } from '../analytics/events';
import './HomePage.css';
import logo from '../assets/logo.png';
import centerLogo from '../assets/center-logo.png';
import heroBanner from '../assets/hero-banner.png';
import mainImage from '../assets/main-image.png';
import secondaryImage from '../assets/secondary-image.png';
import secondaryImage2 from '../assets/secondary-image-2.png';
import sparkleIcon from '../assets/sparkle-icon.png';
import vendorIcon from '../assets/vendor-icon.png';
import brokersIcon from '../assets/brokers-icon.png';
import agentsIcon from '../assets/agents-icon.png';
import clientsIcon from '../assets/clients-icon.png';
import sunilPathakImage from '../assets/sunil-pathak.png';
import juanRodriguezImage from '../assets/Juan-rodriguez.jpeg';
import bpatniImage from '../assets/Bhupendra.png';
import dharmendraImage from '../assets/Dharmendra.jpeg';
import jayaImage from '../assets/Jaya.jpeg';
import sakhiImage from '../assets/Sakhi.png';
import krishnaImage from '../assets/Krishna.png';
import shwetamage from '../assets/Shweta.jpg';

import Header from '../components/layout/Header';

const HomePage = () => {
  const location = useLocation();
  const features = [
    {
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M21 15C21 15.5304 20.7893 16.0391 20.4142 16.4142C20.0391 16.7893 19.5304 17 19 17H7L3 21V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V15Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      ),
      title: 'Conversational Interface',
      description: 'Chat naturally with Ria to manage your entire real estate workflow without clicking through complex menus.'
    },
    {
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M10 9H9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      ),
      title: 'Document Management',
      description: 'Organize, search, and retrieve all your contracts, disclosures, and forms instantly with AI-powered understanding.'
    },
    {
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <circle cx="9" cy="7" r="4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M23 21V19C22.9993 18.1137 22.7044 17.2528 22.1614 16.5523C21.6184 15.8519 20.8581 15.3516 20 15.13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M16 3.13C16.8604 3.35031 17.623 3.85071 18.1676 4.55232C18.7122 5.25392 19.0078 6.11683 19.0078 7.005C19.0078 7.89318 18.7122 8.75608 18.1676 9.45769C17.623 10.1593 16.8604 10.6597 16 10.88" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      ),
      title: 'Unified Communication',
      description: 'Keep agents, clients, brokers, and service providers connected with intelligent message routing and context.'
    },
    {
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8 11V20M12 7V20M16 14V20" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/>
          <path d="M5 20H19" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
        </svg>
      ),
      title: 'Transaction Tracking',
      description: 'Monitor every deal stage, deadline, and milestone with automated updates and smart reminders.'
    },
    {
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="3" y="4" width="18" height="18" rx="2" ry="2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M16 2V6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M8 2V6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M3 10H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      ),
      title: 'Smart Scheduling',
      description: 'Coordinate showings, inspections, and closings with AI that understands everyone\'s availability.'
    },
    {
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 22C12 22 20 18 20 12V5L12 2L4 5V12C4 18 12 22 12 22Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      ),
      title: 'Secure & Compliant',
      description: 'Bank-level encryption and real estate compliance built in, so your data and transactions stay protected.'
    }
  ];

  const howItWorksSteps = [
    {
      number: '01',
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3 8L10.89 13.26C11.2187 13.4793 11.6049 13.5963 12 13.5963C12.3951 13.5963 12.7813 13.4793 13.11 13.26L21 8M5 19H19C19.5304 19 20.0391 18.7893 20.4142 18.4142C20.7893 18.0391 21 17.5304 21 17V7C21 6.46957 20.7893 5.96086 20.4142 5.58579C20.0391 5.21071 19.5304 5 19 5H5C4.46957 5 3.96086 5.21071 3.58579 5.58579C3.21071 5.96086 3 6.46957 3 7V17C3 17.5304 3.21071 18.0391 3.58579 18.4142C3.96086 18.7893 4.46957 19 5 19Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      ),
      title: 'Get Invited',
      description: 'Join our exclusive waitlist and receive your invitation to access Ria. We\'re onboarding users in phases to ensure the best experience.'
    },
    {
      number: '02',
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M21 15C21 15.5304 20.7893 16.0391 20.4142 16.4142C20.0391 16.7893 19.5304 17 19 17H7L3 21V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V15Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      ),
      title: 'Connect Workflow',
      description: 'Link your calendar, documents, and contacts. Ria learns your preferences and adapts to how you work in real estate.'
    },
    {
      number: '03',
      icon: <img src={sparkleIcon} alt="Start Conversing" style={{ width: '24px', height: '24px' }} />,
      title: 'Start Conversing',
      description: 'Simply ask Ria what you need. From scheduling showings to tracking deals, manage everything through natural conversation.'
    }
  ];

  const userTypes = [
    {
      icon: <img src={agentsIcon} alt="Agents" style={{ width: '24px', height: '24px' }} />,
      label: 'A',
      title: 'Agents',
      description: 'Manage listings, schedule showings, and close deals faster with Ria at every step.'
    },
    {
      icon: <img src={brokersIcon} alt="Brokers" style={{ width: '24px', height: '24px' }} />,
      label: 'B',
      title: 'Brokers',
      description: 'Oversee your team\'s pipeline, compliance, track performance across all transactions.'
    },
    {
      icon: <img src={clientsIcon} alt="Clients" style={{ width: '24px', height: '24px' }} />,
      label: 'C',
      title: 'Clients',
      description: 'Stay informed in your home journey with instant updates and seamless communication.'
    },
    {
      icon: <img src={vendorIcon} alt="Vendors" style={{ width: '24px', height: '24px' }} />,
      label: 'V',
      title: 'Vendors',
      description: 'Inspectors, appraisers, and contractors—coordinate schedules and share reports.'
    }
  ];

  const teamMembers = [
    {
      name: 'Bhupendra Patni',
      title: 'CEO & Founder',
      description: 'Serial entrepreneur and technology leader building an AI-powered platform for real estate transactions. With 25+ years of experience in designing scalable API-first systems, he is applying AI to standardize workflows, enforce compliance, and unlock efficiency across millions of transactions, positioning it to become a core platform for brokerages. As a licensed real estate agent, Bhupendra is combining technical depth with firsthand industry insight to replace fragmented legacy systems with a unified, AI-first solution to solve high-frequency, high-impact problems across the transaction lifecycle.',
      image: bpatniImage,
      social: { linkedin: 'https://www.linkedin.com/in/bhupendrapatni/', email: '#' }
    },
    {
      name: 'Juan Rodriguez',
      title: 'Head of Sales',
      description: 'Juan brings more than a decade of executive-level experience integrating financial strategy, data-driven decision-making, and scalable operational frameworks. He previously closed 700+ real estate transactions as a California Real Estate Broker, leading high-performing teams and managing full-cycle operations across production, lending, investment, and property management.',
      image: juanRodriguezImage,
      social: { linkedin: 'http://linkedin.com/', email: '#' }
    },
    {
      name: 'Dharmendra Kumar',
      title: 'Head of Engineering',
      description: 'Seasoned fintech executive with 20+ years of progressive experience, including 12 years of leadership at PayPal and Venmo. Expertise in driving innovation, managing high-performing engineering teams, and aligning technology strategies with business goals. Proven track record of delivering scalable solutions, optimizing processes, leading enterprise transformations, and enhancing bottom-line performance. Known for fostering a collaborative and empowering workplace through supportive and people-centric leadership.',
      image: dharmendraImage,
      social: { linkedin: 'http://linkedin.com/', email: '#' }
    },
    {
      name: 'Shweta Thosar',
      title: 'Head of Product',
      description: 'Visionary product leader dedicated to building scalable, high-impact digital platforms. She champions an AI-first product strategy, seamlessly integrating machine learning and intelligent automation into the core product lifecycle to drive innovation and competitive advantage. By blending long-term AI vision with disciplined execution and cross-functional alignment, she delivers intuitive, customer-centric solutions that solve complex business challenges and redefine user experiences.',
      image: shwetamage,
      social: { linkedin: 'https://www.linkedin.com/in/shweta-thosar-bba93b15/', email: '#' }
    },
    {
      name: 'Sunil Kishor Pathak',
      title: 'Head of Technology',
      description: "Technology leader with 20+ years at Adobe, Broadcom, and PayPal. Leading Rialty.ai's technology vision—architecting an AI-powered real estate platform on Google Cloud Platform. Expert in cloud architecture, AI/ML, and building products that solve real problems.",
      image: sunilPathakImage,
      social: { linkedin: 'https://www.linkedin.com/in/sunilkpathak/', email: '#' }
    },
    {
      name: 'Sakhi Patni',
      title: 'Marketing Lead',
      description: 'Marketing and community engagement professional with experience building brands, growing audiences,and creating impactful outreach initiatives across healthcare, nonprofit, and technology sectors. Graduated from the University of California, Irvine with a B.S. in Biological Sciences and a minor in Health Informatics, and currently pursuing post-baccalaureate studies at the University of Pennsylvania. Leads marketing and content strategy for Rialty.ai, combining data-driven storytelling with digital marketing to connect innovative technology solutions with their audiences.',
      image: sakhiImage,
      social: { linkedin: 'http://linkedin.com/', email: '#' }
    },
    {
      name: 'Jaya Jaware',
      title: 'Financial Advisor',
      description: 'Jaya Jaware, currently CFO at Leandata, is a highly effective Strategic Finance Executive specializing in scaling high-growth, VC-backed technology companies. She has a proven history of driving substantial value by raising over $355M in capital, executing successful M&A and corporate exits, and significantly improving unit economics. Jaya excels at building robust G&A functions and providing the strategic financial and operational leadership required to transition companies through rapid growth and successful funding cycles.',
      image: jayaImage,
      social: { linkedin: 'http://linkedin.com/', email: '#' }
    },
    {
      name: 'Krishna Baderia',
      title: 'Technology Advisor',
      description: 'Krishna Baderia is a technology executive, founder of Hvantage Technologies, and an expert in cloud, AI, and enterprise architecture. With 20+ years leading digital transformation across financial services and real estate, Krishna advises startups on scalable product strategy and technical execution. He brings deep experience in workflow automation, data engineering, and AI-driven platforms. Krishna supports the team in building a next-generation, AI-powered solution for seamless real-estate transactions.',
      image: krishnaImage,
      social: { linkedin: 'http://linkedin.com/', email: '#' }
    }
  ];

  return (
    <div className="home-page">
      {/* Main Container - Header + Hero Section */}
      <div className="header-hero-container">
        <Header />
        {/* Hero Section */}
        <section className="hero-section">
        <div className="hero-container">
          <div className="hero-content">
            <div className="hero-text">
              <div className="quote-mark">&ldquo;</div>
              <h1 className="hero-title">Ria, show me my active transactions.</h1>
              <p className="hero-response">Done.</p>
              <div className="hero-divider"></div>
              <p className="hero-description">
                Work the way you talk &mdash; manage deals, share documents, and close faster, all through conversation.
              </p>
            </div>
            <div className="hero-images">
              <div className="hero-mockup-container">
                <img src={mainImage} alt="Main Device" className="hero-main-image" />
                <img src={secondaryImage} alt="Secondary Device" className="hero-secondary-image" />
                <img src={secondaryImage2} alt="Secondary Device 2" className="hero-secondary-image-2" />
              </div>
            </div>
          </div>
        </div>
      </section>
      </div>
      {/* End Main Container */}



      {/* Main Features Section */}
      <section className="features-section" id="how-ria-helps">
        <div className="features-container">
          <h2 className="section-title">Everything You Need, One Conversation Away</h2>
          <p className="section-subtitle">
            Ria understands real estate, so you can focus on what matters&mdash;closing deals and serving clients.
          </p>

          {/* First Row - 3 Features */}
          <div className="features-row">
            {features.slice(0, 3).map((feature, index) => (
              <div className="feature-card" key={index}>
                <div className="feature-icon">
                  {feature.icon}
                </div>
                <h3 className="feature-title">{feature.title}</h3>
                <p className="feature-description">{feature.description}</p>
              </div>
            ))}
          </div>

          {/* Second Row - 3 Features */}
          <div className="features-row">
            {features.slice(3, 6).map((feature, index) => (
              <div className="feature-card" key={index + 3}>
                <div className="feature-icon">
                  {feature.icon}
                </div>
                <h3 className="feature-title">{feature.title}</h3>
                <p className="feature-description">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <section className="how-it-works-section">
        <div className="how-it-works-container">
          <h2 className="section-title">How It Works</h2>
          <p className="section-subtitle">
            Get started with Ria in three simple steps and transform the way you manage real estate.
          </p>

          <div className="steps-grid">
            {howItWorksSteps.map((step, index) => (
              <div className="step-card" key={index}>
                <div className="step-number">{step.number}</div>
                <div className="step-icon">
                  <span>{step.icon}</span>
                </div>
                <h3 className="step-title">{step.title}</h3>
                <p className="step-description">{step.description}</p>
                {index < howItWorksSteps.length - 1 && <div className="step-arrow">→</div>}
              </div>
            ))}
          </div>

          <div className="cta-container">
            <p className="cta-text">Ready to experience the future of real estate?</p>
            <Link
              to="/contact"
              className="btn-cta"
              onClick={() => track(EVENTS.CTA_CLICK, { element_label: 'request_invitation', source_screen: location.pathname })}
            >
              Request Your Invitation
            </Link>
          </div>
        </div>
      </section>

      {/* Our Users Section */}
      <section className="users-section" id="users"> 
        <div className="users-container">
          <h2 className="section-title">Our Users</h2>
          <p className="section-subtitle">
            Connecting every stakeholder in the real estate ecosystem through intelligent conversation.
          </p>

          <div className="users-diagram">
            <div className="users-grid">
              {userTypes.map((user, index) => (
                <div className="user-card" key={index}>
                  <div className="user-badge">
                    <span className="user-icon">{user.icon}</span>
                    <span className="user-label">{user.label}</span>
                  </div>
                  <h3 className="user-title">{user.title}</h3>
                  <p className="user-description">{user.description}</p>
                </div>
              ))}
            </div>
            <div className="center-logo">
              <div className="ria-logo-circle">
                <img src={centerLogo} alt="Rialty.AI" className="center-logo-img" />
              </div>
            </div>
          </div>

          <p className="users-tagline">
            No matter your role, Ria adapts to your workflow and connects you with the right people at the right time.
          </p>
        </div>
      </section>

      {/* Team Section */}
      <section className="team-section" id="team">
        <div className="team-container">
          <h2 className="section-title">Meet Our Team</h2>
          <p className="section-subtitle">
            A dedicated group of real estate and technology experts committed to transforming the industry.
          </p>

          <div className="team-grid">
            {teamMembers.map((member, index) => (
              <div className="team-card" key={index}>
                <div className="team-photo-placeholder">
                  <img src={member.image} alt={member.name} className="team-photo" />
                </div>
                <h3 className="team-name">{member.name}</h3>
                <p className="team-title">{member.title}</p>
                <p className="team-description">{member.description}</p>
                {/* {member.highlights && member.highlights.length > 0 && (
                  <div className="team-highlights">
                    <p className="team-highlights-label">KEY HIGHLIGHTS</p>
                    <ul className="team-highlights-list">
                      {member.highlights.map((h, hi) => (
                        <li key={hi}>{h}</li>
                      ))}
                    </ul>
                  </div>
                )} */}
                <div className="team-social">
                  {member.social.linkedin && (
                    <a href={member.social.linkedin} target='_blank' className="social-link" aria-label="LinkedIn">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                        <path d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z" fill="currentColor"/>
                        <circle cx="4" cy="4" r="2" fill="currentColor"/>
                      </svg>
                    </a>
                  )}
                  {member.social.email && (
                    <a href={`mailto:${member.social.email}`} target='_blank' className="social-link" aria-label="Email">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" stroke="currentColor" strokeWidth="2"/>
                        <polyline points="22,6 12,13 2,6" stroke="currentColor" strokeWidth="2"/>
                      </svg>
                    </a>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* About Us Section */}
      <section className="about-section" id="about">
        <div className="about-container">
          <h2 className="section-title">About Us</h2>
          <p className="about-description">
            Rialty.ai brings clarity and connection to the real estate process.
          </p>
          <p className="about-description-1">
            Our conversational platform bridges communication gaps between agents, brokers, clients, and vendors &mdash; helping teams close deals faster and serve their clients better.
          </p>

          <div className="about-highlight">
            <p>We're currently onboarding select partners through an invite-only program.</p>
          </div>

          <div className="about-values">
            <div className="value-card">
              <div className="value-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2C12 2 9 5 9 9C9 10.5913 9.63214 12.1174 10.7574 13.2426C11.8826 14.3679 13.4087 15 15 15C16.5913 15 18.1174 14.3679 19.2426 13.2426C20.3679 12.1174 21 10.5913 21 9C21 5 18 2 18 2C18 2 17 4 15 4C13 4 12 2 12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M7.5 11C7.5 11 6 13.5 6 16C6 17.0609 6.42143 18.0783 7.17157 18.8284C7.92172 19.5786 8.93913 20 10 20C11.0609 20 12.0783 19.5786 12.8284 18.8284C13.5786 18.0783 14 17.0609 14 16C14 13.5 12.5 11 12.5 11C12.5 11 11.75 12.5 10 12.5C8.25 12.5 7.5 11 7.5 11Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <h3 className="value-title">Clear Communication</h3>
              <p className="value-description">No more scattered messages across multiple platforms</p>
            </div>
            <div className="value-card">
              <div className="value-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <circle cx="9" cy="7" r="4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M23 21V19C22.9993 18.1137 22.7044 17.2528 22.1614 16.5523C21.6184 15.8519 20.8581 15.3516 20 15.13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M16 3.13C16.8604 3.35031 17.623 3.85071 18.1676 4.55232C18.7122 5.25392 19.0078 6.11683 19.0078 7.005C19.0078 7.89318 18.7122 8.75608 18.1676 9.45769C17.623 10.1593 16.8604 10.6597 16 10.88" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <h3 className="value-title">Connected Teams</h3>
              <p className="value-description">Everyone stays in sync, from first contact to closing</p>
            </div>
            <div className="value-card">
              <div className="value-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M13 2L3 14H12L11 22L21 10H12L13 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <h3 className="value-title">Faster Closings</h3>
              <p className="value-description">Streamlined processes mean deals move forward quickly</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HomePage;
